import React, { Component } from "react";

import { CCard, CCardBody, CRow, CCol, CLink } from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

import "./style.css";

class ActivityMe extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activities: [],
      loading: true
    };
  }

  friendlyDate(date) {
    const dt = new Date(date);
    const hj = new Date();
    const months = [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro"
    ];

    if (dt.getFullYear() !== hj.getFullYear()) {
      return `${dt.getDate()} de ${
        months[dt.getMonth()]
      } de ${dt.getFullYear()}`;
    }

    return `${dt.getDate()} de ${
      months[dt.getMonth()]
    }, às ${`00${dt.getHours()}`.slice(-2)}:${`00${dt.getMinutes()}`.slice(
      -2
    )}`;
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  }

  getActivities(from, to, prefix) {
    const today = new Date();
    const year = today.getFullYear();

    axios
      .post(
        `${URL.api}activity/activity/filter`,
        {
          user: this.props.user.user.id,
          from: `${year}-01-01 00:00:00`,
          to: `${year}-12-31 23:59:59`
        },
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(
        resp => {
          this.setState({
            activities: this.group(resp.data.data),
            loading: false
          });
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  group(myArray) {
    let months = [
      "Jan",
      "Fev",
      "Mar",
      "Abr",
      "Mai",
      "Jun",
      "Jul",
      "Ago",
      "Set",
      "Out",
      "Nov",
      "Dez"
    ];
    let days = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];

    let groups = myArray.reduce((r, o) => {
      const dt = new Date(o.activity_start);

      let m = `${days[dt.getDay()]}/${`00${dt.getDate()}`.slice(-2)}/${
        months[dt.getMonth()]
      }/${dt.getFullYear()}`;
      r[m] ? r[m].data.push(o) : (r[m] = { group: m, data: [o] });
      return r;
    }, {});

    let result = Object.keys(groups).map(k => groups[k]);

    return result;
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    this.getActivities();
  }

  render() {
    return (
      <>
        <Breadcrumb current={this.props.currentRoute} />
        {this.state.loading ? (
          <Loading />
        ) : this.state.activities && this.state.activities.length > 0 ? (
          this.state.activities.map(day => (
            <CRow>
              <CCol
                sm="12"
                md="1"
                className="d-flex flex-column align-items-center"
              >
                <h1>{day.group.split("/")[0]}</h1>
                <h4 className="text-muted mb-4">
                  {`${day.group.split("/")[1]} ${day.group.split("/")[2]}`}
                </h4>
              </CCol>
              <CCol sm="12" md="11">
                <div className="mb-4">
                  {day.data.map(activity => (
                    <CLink
                      to={`/activity/do/${activity.allocation_id}`}
                      key={activity.id}
                      className="not-link"
                    >
                      <CCard key={activity.id} className="activity-card">
                        <CCardBody>
                          <div className="d-flex align-items-center">
                            <i
                              className="fa fa-check-circle-o mr-3 text-primary"
                              style={{ fontSize: "1.25rem" }}
                            ></i>
                            <div
                              className="mr-3 d-flex"
                              style={{
                                flex: 1,
                                fontSize: "1rem",
                                fontWeight: "bold"
                              }}
                            >
                              {activity.name}
                            </div>
                            <div className="mr-3 d-flex" style={{ flex: 1 }}>
                              {activity.description}
                            </div>
                            <div
                              className="text-muted mr-3 d-flex"
                              style={{ flex: 1 }}
                            >
                              <i className="fa fa-clock mr-2"></i>Acaba em{" "}
                              {this.friendlyDate(activity.activity_start)}
                            </div>
                            <div className="c-avatar mr-3">
                              <img
                                className="c-avatar-img"
                                alt=""
                                src={
                                  URL.img +
                                  (activity.user_photo ||
                                    "uploads/users/profileEmpty.jpg")
                                }
                              />
                            </div>
                            <span>{activity.user_name}</span>
                          </div>
                        </CCardBody>
                      </CCard>
                    </CLink>
                  ))}
                </div>
              </CCol>
            </CRow>
          ))
        ) : (
          <div className="d-flex align-items-center justify-content-center m-3">
            Nenhum aviso encontrado
          </div>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ActivityMe);
